import React from 'react';
import PitchEntity from './PitchEntity'
import { getInterval } from './gameJson'
import  PlayerMoveTo  from '../Animations/Movements/PlayerMoveTo'

class Linesman extends PitchEntity {

    static propTypes = {
        home: React.PropTypes.bool.isRequired,
        sidesChanged: React.PropTypes.bool.isRequired,
        convertToPitchPosition: React.PropTypes.func.isRequired,
        getKeyPoints: React.PropTypes.func.isRequired,
        pitchWidth: React.PropTypes.number.isRequired
    }

    constructor(props) {
        super(props);

        this.CurrentPosition = this.props.getKeyPoints(this.props.home).startPoint; 
        this.showOffside = false;
    }

    readEvent(eventNum){
        var isHome = this.props.home;

        if(eventNum == 0){
            return { position: this.CurrentPosition, time: 1000};
        }

        var currentEventCoordsSet = window.Json.game[eventNum-1].coordinates;
        var time = getInterval(eventNum-1);

        if(currentEventCoordsSet == null)
            return { position: this.CurrentPosition, time: time};

        var homeOrAway = null;
        if(isHome) {
            homeOrAway = !this.props.sidesChanged ? currentEventCoordsSet.home : currentEventCoordsSet.away;
        }
        else {
            homeOrAway = !this.props.sidesChanged ? currentEventCoordsSet.away : currentEventCoordsSet.home;
        }
        let minLeft = this.props.pitchWidth / 2;
        for (var index = 1; index < homeOrAway.length; index++) {
            var pos = homeOrAway[index];
            if(!this.props.sidesChanged) {
                if(pos.w < minLeft && pos.w > -80)
                    minLeft = pos.w;
            } else {
                if(pos.w > minLeft && pos.w < 800)
                    minLeft = pos.w;
            }
        }

        var position = {
            Top:  -10,
            Left: !this.props.sidesChanged ? minLeft : this.props.pitchWidth - minLeft,
        };

        return { position, time };
    }

    startOffsideAnimation() {
        this.showOffside = true;
        this.forceUpdate();
    }
    
    endOffsideAnimation() {
        this.showOffside = false;
    }

    playMovementAnimation(new_position, time, owner, hide) {
        this.endOffsideAnimation();
        this.CurrentAnimation = new PlayerMoveTo(this, time, new_position, false, hide);
          this.CurrentAnimation.Play(this.props.gameSpeed).catch(this.processCancellation);
    }

    cancelPreviousAnimation() {
        this.endOffsideAnimation();
        super.cancelPreviousAnimation();
    }

    render() {
        if(this.CheckIfOutsidePitch())
            return null;
        
        var position = this.props.convertToPitchPosition(this.CurrentPosition, this.props.home);

        var diff = this.getPositionDiff();
        var top = position.Top - diff;
        var left = position.Left - diff;

        const divStyle = {
          top: top + 'px',
          left: left + 'px',
          opacity: this.opacity
        };

        const linesmanShapeStyle = {
          background: '#FFFFFF',
          color: '#000000',
          borderColor: '#000000'
        };

        return (<div style={divStyle} className={this.getContainerClass()}>
                    <div style={linesmanShapeStyle} className={this.showOffside ? "player_shape offside_animation" : "player_shape"}>
                    <div className="player_number">A</div>
                    </div>
                </div>)
    }
    
}

export default Linesman


/** WEBPACK FOOTER **
 ** ./src/components/Pitch/Linesman.js
 **/